import React, { Component, } from 'react'
// import PropTypes from 'prop-types'
import moment from 'moment'

import Modal from 'components/_molecules/Modal'

import EventInfo from 'components/EventInfo'
import PushPinIcon from 'components/icons/PushPin'

import worldMapImg from 'assets/world-map.png'

import './TripListing.css'

const CurrentLocation = () => (
  <div title="current location" className="current-location-indicator">
    <PushPinIcon fill="white" />
  </div>
  )

function renderEvent({
  viewEventInfo,
  event,
  tripId,
  nextEvent,
  isCurrentEvent,
}) {
  const thisDate = event.arrive || event.depart
  const nextDate = nextEvent ? nextEvent.arrive || nextEvent.depart : undefined

  const thisDateDisplay = moment(thisDate).format('Do MMM YYYY')

  // calcluate duration (ignoring first and last dates)
  let duration
  let pluralise
  if (!event.start && thisDate && nextDate) {
    duration = moment(nextDate).diff(moment(thisDate), 'days') + 1
    pluralise = duration > 1 ? 's' : ''
  }

  const onClick = () => {
    viewEventInfo({
      tripId,
      eventId: event.id,
    })
  }

  return (
    <li key={event.id}>
      <div className="event">
        {isCurrentEvent && <CurrentLocation />}
        <div className="date">{thisDateDisplay}</div>
        <div className="descr-container">
          <a className="descr" onClick={onClick}>
            {' '}
            {event.name}{' '}
          </a>
          <div className="duration">
            {' '}
            {duration && `(${duration} Day${pluralise})`}{' '}
          </div>
        </div>
      </div>
    </li>
  )
}

class TripListing extends Component {
  static propTypes = {}

  static defaultProps = {}

  goToNextEvent = () => {
    const { selectedEventNextEventId: eventId, tripId, } = this.props
    this.props.viewEventInfo({ tripId, eventId, })
  }

  goToPreviousEvent = () => {
    const { selectedEventPreviousEventId: eventId, tripId, } = this.props
    this.props.viewEventInfo({ tripId, eventId, })
  }

  render() {
    const { goToNextEvent, goToPreviousEvent, } = this
    const {
      tripId,
      tripData,
      viewEventInfo,
      hideEventInfo,
      selectedEventData,
      selectedEventInfoDisplayed,
      selectedEventPreviousEvent,
      selectedEventNextEvent,
      currentEventId,
    } = this.props
    const { name, } = tripData

    const eventInfo = {
      event: selectedEventData,
      previousEvent: selectedEventPreviousEvent,
      nextEvent: selectedEventNextEvent,
      close: hideEventInfo,
      hasNextEvent: !!selectedEventNextEvent,
      hasPreviousEvent: !!selectedEventPreviousEvent,
      goToNextEvent,
      goToPreviousEvent,
    }

    let selectedEventTitle = ''
    if (selectedEventData && currentEventId === selectedEventData.id) {
      selectedEventTitle = (
        <div>
          {' '}
          <PushPinIcon fill="white" /> {selectedEventData.name}{' '}
        </div>
      )
    } else if (selectedEventData) {
      selectedEventTitle = selectedEventData.name
    }

    return (
      <div
        data-component="TripListing"
        style={{ backgroundImage: `url(${worldMapImg})`, }}
      >
        {!selectedEventInfoDisplayed && (
          <div className="foreground">
            <div className="listing">
              <h1>{name}</h1>
              <ul>
                {tripData.events.map((event, index) =>
                  renderEvent({
                    tripId,
                    viewEventInfo,
                    event,
                    nextEvent: tripData.events[index + 1]
                      ? tripData.events[index + 1]
                      : undefined,
                    isCurrentEvent: !!(currentEventId === event.id),
                  })
                )}
              </ul>
            </div>
            <div className="version-display">v 2.0.7</div>
          </div>
        )}
        <Modal
          isOpen={selectedEventInfoDisplayed}
          modalTitle={selectedEventTitle}
          onRequestClose={hideEventInfo}
          additionalClassName="trip-listing-modal"
        >
          {selectedEventInfoDisplayed && <EventInfo {...eventInfo} />}
        </Modal>
      </div>
    )
  }
}

export default TripListing



// WEBPACK FOOTER //
// ./src/components/TripListing/index.js